export default {
    data: () => ({
        translations: {
            title: {
                el: "Πολιτική Απορρήτου",
                en: "Privacy Policy",
                it: "Politica della privacy"
            },
            info: {
                el: "Ανέβασε τους όρους χρήσης της επιχείρησης (σε μορφή pdf). Eπιλέξτε το αρχείο pdf και μετά πατήστε αποθήκευση.",
                en: `
                    Upload the business privacy policy (in .pdf format). Select the pdf file
                    and then click save.
                `,
                it: "Scarica le condizioni d'uso del business (in formato pdf). Seleziona il file pdf e poi clicca su salva."
            },
            privacyPolicy: {
                el: "Πολιτική Απορρήτου",
                en: "Privacy Policy:",
                it: "Politica della privacy"
            }
        }
    })
};
